import { render, staticRenderFns } from "./OfferTexts.vue?vue&type=template&id=20e5fd76&"
import script from "./OfferTexts.vue?vue&type=script&setup=true&lang=ts&"
export * from "./OfferTexts.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./OfferTexts.vue?vue&type=style&index=0&id=20e5fd76&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports